import { Component, OnInit } from '@angular/core';
import { ProductNames } from '@xbs/xbs-enums';
import { AuthService } from '../../shared/auth.service';
import { SessionService, ContainersService, CountriesService, MessageService } from '../../shared/services';
import { Container } from '../../shared/models';
import { LocalStorageKeys } from '../../shared/constants';

@Component({
  template: ''
})
export class LoginComponent implements OnInit {

  containers: Container[];
  selectedContainer: Container;

  constructor(
    private _authService: AuthService,
    private _containersService: ContainersService,
    private _sessionService: SessionService,
    private _countriesService: CountriesService,
    private _messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.setProductUuid();
    if (this.isRedircetFromLoginUi()) {
      this._authService.onLoginSuccess();
      this.reloadAppOrGetContainers();
    } else {
      this.isUserLoggedIn() ? this.onUserLoggedIn() : this.login();
    }
  }

  private onUserLoggedIn(): void {
    const workingContainer = this._sessionService.getWorkingContainer();
    workingContainer ? this._authService.home() : this.getAllContainersForUser();
  }

  private login(): void {
    this._authService.login();
  }

  private reloadAppOrGetContainers(): void {
    this._authService.checkNewVersionExists().subscribe(
      (newerVersionExists: boolean) => {
        if (newerVersionExists) {
          window.location.replace(`${window.location.origin}/login`);
        } else {
          this.getAllContainersForUser();
        }
      },
      () => window.location.replace(`${window.location.origin}/login`)
    );
  }

  private isUserLoggedIn(): boolean {
    return this._authService.isLoggedIn();
  }

  private isRedircetFromLoginUi(): boolean {
    return this._authService.isRedirectFromLogin();
  }

  private getAllContainersForUser(): void {
    this._containersService.list().subscribe(({ data }) => {
      if (data.length === 0) {
        this._messageService.displayMessage({
          type: 'error',
          body: 'This account has no containers for this product. Please reach out to your Customer Success Manager to ask them to add containers for you.'
        });
        this._authService.logout();
      } else {
        data = data.map((container) => {
          container.displayName = container.name + ' ' + container.taxYear;
          return container;
        });

        this.containers = data;
        this.selectedContainer = this.containers[0];
        this._sessionService.setContainersList(this.containers);
        this.saveAllCountriesInLocalStorage();

        this._containersService.getWorkingContainerEntity().subscribe(({ data: entity }) => {
          if (!entity.container) {
            this._authService.logout();
          } else {
            this._sessionService.setWorkingContainer(entity.container);
            const upeId = entity.entityId || 0;
            const upeCurrency = entity.upeCurrency || null;
            const currencyScale = entity.upeCurrencyScale || 0;
            this._sessionService.setContainerUpeId(upeId);
            this._sessionService.setContainerUpeCurrency(upeCurrency);
            this._sessionService.setContainerUpeCurrencyScale(currencyScale);
            this._authService.home();
          }
        },
        (err) => {
          console.error(err);
          this._authService.logout();
        });
      }
    },
    (err) => {
      console.error(err);
      this._authService.logout();
    });
  }

  private saveAllCountriesInLocalStorage(): void {
    this._countriesService.list().subscribe(({ data }) => {
      this._sessionService.setCountries(data);
    });
  }

  private setProductUuid(): void {
    const productUuid: string = ProductNames.ByName.Tpiq.Uuid;
    localStorage.setItem(LocalStorageKeys.PRODUCT_UUID, productUuid);
  }

}
